// extracted by mini-css-extract-plugin
module.exports = {"CaseStudiesCarousel":"styles_CaseStudiesCarousel__qM_MF","height":"styles_height__f5OaC"};